
        import { CopilotStudioClient } from 'https://unpkg.com/@microsoft/agents-copilotstudio-client@1.0.15/dist/src/browser.mjs';
        window.MicrosoftAgents = { CopilotStudioClient };
    